import { z } from 'zod';
// --- Request Schemas ---
export const GdprDeleteRequestSchema = z.object({
    reason: z.string().max(500).optional(),
});
export const GdprRestrictRequestSchema = z.object({
    action: z.literal('restrict'),
});
// --- Response Sub-Schemas ---
const ClerkExportDataSchema = z.object({
    userId: z.string(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    email: z.string().nullable(),
    avatarUrl: z.string().nullable(),
    createdAt: z.string().nullable(),
    lastSignInAt: z.string().nullable(),
});
const StripeExportDataSchema = z.object({
    customerId: z.string().nullable(),
    subscription: z
        .object({
        id: z.string(),
        status: z.string(),
        plan: z.string().nullable(),
        currentPeriodStart: z.string().nullable(),
        currentPeriodEnd: z.string().nullable(),
    })
        .nullable(),
    invoices: z.array(z.object({
        id: z.string(),
        amountPaid: z.number(),
        currency: z.string(),
        status: z.string(),
        created: z.string(),
    })),
    paymentMethods: z.array(z.object({
        type: z.string(),
        last4: z.string().nullable(),
        brand: z.string().nullable(),
        expiryMonth: z.number().nullable(),
        expiryYear: z.number().nullable(),
    })),
    billingAddress: z
        .object({
        city: z.string().nullable(),
        country: z.string().nullable(),
        line1: z.string().nullable(),
        line2: z.string().nullable(),
        postalCode: z.string().nullable(),
        state: z.string().nullable(),
    })
        .nullable(),
});
const KvExportDataSchema = z.object({
    apiKeys: z.array(z.object({
        label: z.string().nullable(),
        createdAt: z.string(),
        lastUsedAt: z.string().nullable(),
    })),
    onboardingState: z.unknown().nullable(),
    planData: z.unknown().nullable(),
});
const UpstashExportDataSchema = z.object({
    tokenBalance: z.number().nullable(),
    monthlyAllocation: z.number().nullable(),
    rateLimitCounters: z.record(z.string(), z.number()).nullable(),
});
// --- Top-Level Response Schemas ---
export const GdprExportResponseSchema = z.object({
    exportedAt: z.string(),
    userId: z.string(),
    data: z.object({
        clerk: ClerkExportDataSchema,
        stripe: StripeExportDataSchema,
        kv: KvExportDataSchema,
        upstash: UpstashExportDataSchema,
    }),
    errors: z
        .array(z.object({
        store: z.string(),
        message: z.string(),
    }))
        .optional(),
});
export const GdprDeleteResponseSchema = z.object({
    status: z.literal('pendingDeletion'),
    requestedAt: z.string(),
    scheduledHardDelete: z.string(),
});
export const GdprCancelDeletionResponseSchema = z.object({
    status: z.literal('restored'),
    restoredAt: z.string(),
});
export const GdprAccountStatusSchema = z.object({
    status: z.enum(['active', 'pendingDeletion', 'restricted']),
    scheduledHardDelete: z.string().optional(),
    restrictedAt: z.string().optional(),
});
//# sourceMappingURL=gdpr.js.map